var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCredentialsBlackIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.41667H12M17.5 3.75H1M14.75 11.0833H12M10.1667 13.8333C9.81833 12.2658 8.30583 11.0833 6.5 11.0833C4.69417 11.0833 3.18167 12.2658 2.83333 13.8333M3.93333 13.8333H14.5667C15.5933 13.8333 16.1067 13.8333 16.5008 13.6317C16.8492 13.4575 17.1242 13.1733 17.2983 12.8342C17.5 12.44 17.5 11.9267 17.5 10.9V3.93333C17.5 2.90667 17.5 2.39333 17.2983 1.99917C17.1242 1.65083 16.84 1.37583 16.5008 1.20167C16.1067 1 15.5933 1 14.5667 1H3.93333C2.90667 1 2.39333 1 1.99917 1.20167C1.65083 1.37583 1.37583 1.66 1.20167 1.99917C1 2.39333 1 2.90667 1 3.93333V10.9C1 11.9267 1 12.44 1.20167 12.8342C1.37583 13.1825 1.66 13.4575 1.99917 13.6317C2.39333 13.8333 2.90667 13.8333 3.93333 13.8333ZM8.05833 7.41667C8.05833 8.27833 7.36167 8.96583 6.50917 8.96583C5.65667 8.96583 4.96 8.26917 4.96 7.41667C4.96 6.56417 5.65667 5.8675 6.50917 5.8675C7.36167 5.8675 8.05833 6.56417 8.05833 7.41667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCredentialsBlackIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credentialsBlackIcon.97e16d433e5c2d64b52b52c7f5c7331a.svg";